module.exports = __webpack_public_path__ + "media/images/flags/16/New-Caledonia-f0d10e440db102ecc0b43d4ac305db49.png";